import React from "react";
import ReactDOM from "react-dom"
import SubNavigation from "../../all/SubNavigation";

let data = {
    items : [
        {
            text: i18njs["Solutions.Scenarios"],
            href: "javascript:VerticalSmoothScrollTo('scenariosSection', -150)"
        },
        {
            text: i18njs["Solutions.OssSmartApps"],
            href: "javascript:VerticalSmoothScrollTo('optomaSolutionsSuiteSection', -150)"
        },
        {
            text: i18njs["Solutions.Oms"],
            href: "javascript:VerticalSmoothScrollTo('optomaManagementSuiteSection', -150)"
        },
        // {
        //     text: i18njs["Solutions.SolutionBuilder"],
        //     href : "javascript:VerticalSmoothScrollTo('solutionsBuilderLinkToSection', -150)"
        // },
        {
            text: i18njs["Solutions.Products"],
            href: "javascript:VerticalSmoothScrollTo('productsSection', -150)"
        },
        {
            text: i18njs["Solutions.CaseStudies"],
            href: "javascript:VerticalSmoothScrollTo('caseStudiesSection', -150)"
        },
        {
            text: i18njs["Solutions.ResourcesSupportAndFAQs"],
            href: "javascript:VerticalSmoothScrollTo('resourcesSection', -150)"
        }
    ],
    buttonText: i18njs["Solutions.LinkMyAcct"],
    buttonHref : "#myaccount"
}

const htmlElement = document.getElementById("solutionsnav-app");
const root = ReactDOM.createRoot(htmlElement);
root.render(<SubNavigation data={data} />)